module.exports = __webpack_public_path__ + "img/interswitch.69bbff44.png";